/*=========================================================================================
  File Name: moduleSpace.js
  Description: Space Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleNoticeState.js'
import mutations from './moduleNoticeMutations.js'
import actions from './moduleNoticeActions.js'
import getters from './moduleNoticeGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
